import axios from "axios";

const api = "https://api.jawanpakistan.com/";

const getadminallassignments = () => async (dispatch) => {
  dispatch({ type: "GET_ADMIN_ASSIGNMENT" });

  axios
    .get(`${api}assignment/getallassigments`)
    .then((res) => {
      console.log(res.data);
      dispatch({
        type: "GET_ADMIN_ASSIGNMENT_SUCCESS",
        payload: res.data.data,
      });
    })
    .catch((err) => {
      dispatch({ type: "GET_ADMIN_ASSIGNMENT_ERROR", payload: err.message });
      // console.log(err);
    });
};

const getsinglestdassignment = (id) => async (dispatch) => {

  console.log('pokkaaa', id);
  dispatch({ type: "GET_ADMIN_SINGLE_ASSIGNMENT", id });
};

const filterassignments =
  (city, institute, course, batch, time) => async (dispatch) => {
    dispatch({
      type: "FILTER_ASSIGNMENTS",
      city,
      institute,
      course,
      batch,
      time,
    });
  };

const emptyassignment = () => async (dispatch) => {
  dispatch({ type: "EMPTY_ASSIGNMENTS" });
};

const givestdmarks =
  (id, rollNo, obtainMarks, assignmentName) => async (dispatch) => {
    dispatch({ type: "GIVE_STD_MARKS" });

    const obj = {
      id,
      rollNo,
      obtainMarks,
      assignmentName,
    };

    console.log(obj)

    const options = {
      method: "PUT",
      headers: { Accept: "application/json" },
      data: obj,
      url: `${api}assignment/stdmarkass`,
    };

    axios(options).then((res) => {
      console.log(res)
      dispatch({ type: 'GIVE_STD_MARKS_SUCCESS' })
    })
      .catch((err) => {
        dispatch({ type: "GIVE_STD_MARKS_ERROR" })
      });
  };

const AddComment = (id, rollNo, name, time, text, toast) => async (dispatch) => {

  dispatch({ type: "ADD_STD_ASSIGNMENT_COMMENT" });

  const obj = {
    id,
    rollNo,
    name,
    time,
    text
  }

  console.log(obj)

  const options = {
    method: "PATCH",
    headers: { Accept: "application/json" },
    data: obj,
    url: 'https://api.jawanpakistan.com/assignment/addcomments'
  }

  axios(options).then((res) => {
    console.log(res)
    console.log(res.data)
    dispatch({ type: "ADD_STD_ASSIGNMENT_COMMENT_SUCCESS" });
    toast('Comment has been added')
  }).catch(err => {
    dispatch({ type: "ADD_STD_ASSIGNMENT_COMMENT_ERROR" });
    toast('Error in adding Comment')
  })

}

export {
  getadminallassignments,
  getsinglestdassignment,
  filterassignments,
  emptyassignment,
  givestdmarks,
  AddComment
};
